import { render } from "./success-alert-cashout.vue?vue&type=template&id=627d8ea2&scoped=true"
import script from "./success-alert-cashout.vue?vue&type=script&lang=js"
export * from "./success-alert-cashout.vue?vue&type=script&lang=js"

import "./success-alert-cashout.vue?vue&type=style&index=0&id=627d8ea2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-627d8ea2"

export default script